

/**
 * @param {string} top
 * @param {string} middle
 * @param {string} bottom
 * @param {number} size
 */
export function generateHotspotImage(canvas, top, middle, bottom, size = 200) {
	const ctx = canvas.getContext('2d');

	const sizeHalf = size / 2;
	const sizePercent = sizeHalf / 100;

	ctx.fillStyle = 'rgba(0,0,0,0.4)';
	ctx.beginPath();
	ctx.arc(sizeHalf, sizeHalf, sizeHalf, 0, 2 * Math.PI);
	ctx.closePath();
	ctx.fill();

	ctx.fillStyle = 'rgba(255,255,255,0.8)';
	writeCenteredText(ctx, size, sizePercent * 40, sizePercent * 20, top);
	writeCenteredText(ctx, size, sizePercent * 120, sizePercent * 80, middle);
	writeCenteredText(ctx, size, sizePercent * 160, sizePercent * 30, bottom);

	return canvas;
}

export function writeCenteredText(ctx, width, y, fontSize, title) {
	let titleSize, initialHeight;
	do {
		ctx.font = `${fontSize}px bold "Lato","Arial"`;
		titleSize = ctx.measureText(title);

		// Hack to figure out title height based on a square-ish letter
		//noinspection JSSuspiciousNameCombination
		titleSize.height = ctx.measureText('M').width;

		// Reduce font size until we fit inside the assigned width
		fontSize -= 5;

		// Remember initial height, so we can adjust y based on changed height
		if (!initialHeight) {
			initialHeight = titleSize.height;
		}
	}
	while (titleSize.width > width - 10);

	y -= (initialHeight - titleSize.height) / 2;
	ctx.fillText(title, (width - titleSize.width) / 2, y);
}
